import getLoanApplicationCheckStatusApiCall from 'api/calls/getLoanApplicationCheckStatusCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

const useLoanApplicationCheckStatusQuery = (
  refetchInterval: number | false = false,
) => {
  const { token } = useAuth();
  const query = useProtectedQuery(
    ['getLoanApplicationCheckStatusApiCall', token],
    getLoanApplicationCheckStatusApiCall,
    { refetchInterval },
  );

  return query;
};

export default useLoanApplicationCheckStatusQuery;
